import { useState, useEffect } from "react";

const useLightbox = () => {
  const [lightbox, setLightbox] = useState(null);
  const [visible, setVisible] = useState(false);

  const openLightbox = (img) => {
    setLightbox(img);
    setTimeout(() => setVisible(true), 10);
    window.history.pushState({ lightbox: true }, "");
  };

  const closeLightbox = (fromPopState = false) => {
    setVisible(false);
    setTimeout(() => setLightbox(null), 350);
    if (!fromPopState) window.history.back();
  };

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeLightbox(); };
    const onPop = () => { if (lightbox) closeLightbox(true); };
    window.addEventListener("keydown", onKey);
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("popstate", onPop);
    };
  });

  return { lightbox, visible, openLightbox, closeLightbox };
};

export default useLightbox;
